import { put, takeLatest } from 'redux-saga/effects'
import url from 'url';

import * as actions from '../actions/ExhibitorFloor'
import * as actionTypes from '../../constants/actionTypes'
import exhibFloorAPI from '../../api/ExhibitorFloor'

const masterapp = 'https://xcdsystem.com/masterapp_summer2012';

let api_url = "/" + masterapp + "/admin2015/exhibitors/new_floorplan/booth_ajax.cfc";
if (masterapp.startsWith("http")) {
   api_url = masterapp + "/admin2015/exhibitors/new_floorplan/booth_ajax.cfc";
}
let url_obj = url.parse(window.location.href);
let hostname = url_obj.hostname;
let source_hex = null;
if (hostname != "localhost") {
   source_hex = hostname.split(".")[0];
}

function* fetchExhibConfigInfo() {
   try {
      const result = yield (exhibFloorAPI.fetchExhibFloorConfig());
      yield put(actions.fetchTagsInfoRequest(result));
      yield put(actions.fetchBoothConfigurationRequest({api_url, source_hex, ConfID: result['exhibitor_confid']}));
      yield put(actions.fetchCompanyInfoRequest({confid: result['exhibitor_confid'], conferenceid: result['conferenceid']}));
      if (result) {
         yield put(actions.fetchExhibFloorInfoSuccess(result))
      } else {
         yield put(actions.fetchExhibFloorInfoFailure(result))
      }
   } catch (err) {
      yield put(actions.fetchExhibFloorInfoFailure())
   }
}

function* fetchCompanyInfo(action) {
   try {
      const result = yield (exhibFloorAPI.fetchCompanyDetails(action.payload))
      let exhibitor_hashmap = {};
      let exhibitorsInfo = {};
      result.map((exhibitor) => {
         exhibitor_hashmap[exhibitor.CompanyInfo.CompID] = {...exhibitor.CompanyInfo};
         exhibitorsInfo[exhibitor.CompanyInfo.CompID] = {...exhibitor};
      });
      let hashMap = {
         exhibitors: exhibitor_hashmap,
         exhibitorsInfo
      }
      if (result) {
         yield put(actions.fetchCompanyInfoSuccess(result))
         yield put(actions.updateExhibitorHashMap(hashMap))
      } else {
         yield put(actions.fetchCompanyInfoFailure(result))
      }
   } catch (err) {
      yield put(actions.fetchCompanyInfoFailure())
   }
}

function* fetchTagsInfo(action) {
   try {
      const result = yield (exhibFloorAPI.fetchTagsDetails(action.payload))
      if (result) {
         yield put(actions.fetchTagsInfoSuccess(result))
      } else {
         yield put(actions.fetchTagsInfoFailure(result))
      }
   } catch (err) {
      yield put(actions.fetchTagsInfoFailure())
   }
}

function* fetchBoothConfiguration(action) {
   try {
      const result = yield (exhibFloorAPI.fetchBoothConfigurations(action.payload))
      if (result) {
         yield put(actions.fetchBoothConfigurationSuccess(result))
      } else {
         yield put(actions.fetchBoothConfigurationFailure(result))
      }
   } catch (err) {
      yield put(actions.fetchBoothConfigurationFailure())
   }
}

export default function* watchFetchCompanySaga() {
   yield takeLatest(actionTypes.FETCH_EXHIBFLOOR_INFO_REQUEST, fetchExhibConfigInfo);
   yield takeLatest(actionTypes.FETCH_COMPANY_INFO_REQUEST, fetchCompanyInfo);
   yield takeLatest(actionTypes.FETCH_TAGS_REQUEST, fetchTagsInfo);
   yield takeLatest(actionTypes.FETCH_BOOTH_CONFIGURATION_REQUEST, fetchBoothConfiguration)
}